import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
const formatRelativeTime = (timestamp, locale = 'en', capitalized = false) => {
    if (!timestamp)
        return '';
    const text = dayjs(timestamp).locale(locale).fromNow(true);
    if (!capitalized)
        return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
};
export default formatRelativeTime;
